module.exports = __webpack_public_path__ + "img/mazatlan_home_banner_2.44e05c2f.jpeg";